import moment from 'moment-jalaali';

export const getDate = (date: string, jalaaliFlag: boolean) => {
    if (!date) {
        return;
    }
    if (jalaaliFlag) {
        return moment(date).format('jYY/jM/jD');
    }
    return moment(date).format('YY-M-D');
};
export const getDateTime = (date: string, jalaaliFlag: boolean) => {
    if (!date) {
        return;
    }
    if (jalaaliFlag) {
        return moment(date).format('jYY/jM/jD hh:mm');
    }
    return moment(date).format('YY-M-D hh:mm');
};
export const isIsoDate = (str: string) => {
    if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}/.test(str)) {
        return false;
    }
    return true;
};
